module.exports = __webpack_public_path__ + "img/no_bg.0f424c84.png";